<template>
  <div class="card">
    <div class="card-header">
      <span class="text-header">Recibo da sessão</span>
    </div>
    <div class="card-body">
      <ul class="list-group list-group-flush">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{ 'border-0': !item.receipt }"
        >
          <span class="text-paragraph">CPF</span>
          <span v-if="item.user?.document_number" class="text-subtitle">{{
            item.user.document_number
          }}</span>
        </li>
        <li
          v-if="item.receipt"
          @click="handleReceipt"
          class="list-group-item d-flex justify-content-between align-items-center border-0 cursor-pointer"
        >
          <span class="text-subtitle"
            ><i class="fa-solid fa-receipt me-2"></i>Visualizar recibo</span
          >
          <i class="fa-solid fa-chevron-right text-subtitle"></i>
        </li>
      </ul>
      <Button
        :label="item.receipt ? ' Remover recibo' : 'Anexar recibo'"
        @onClick="
          item.receipt ? handleRemoveReceipt() : openFileUploader(inputId)
        "
        :outline="!!item.receipt"
        fullWidth
        :leftIcon="item.receipt ? '' : 'fa-solid fa-plus-circle'"
        :loading="uploading"
      />
      <FileUploader
        @fileUploaded="handleUploadFile($event)"
        :inputId="inputId"
        :hiddenInput="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import {
  FileBaseUrl,
  type Appointment,
} from "@phurshell/psiapp-frontend-core/domain";
import { openFileUploader } from "@/utils/Helper";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateReceipt } from "@/composables/useAppointments";

const props = defineProps<{ item: Appointment }>();

const uploading = ref(false);
const inputId = "receipt_file_input";

const { mutateAsync: updateReceipt } = useUpdateReceipt();

function handleReceipt() {
  window.open(`${FileBaseUrl}${props.item.receipt}`, "_blank");
}

async function handleUploadFile(file: any) {
  try {
    uploading.value = true;
    await updateReceipt({ id: props.item.id, receipt: file.file });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Recibo anexado",
      msg: "Recibo foi anexado e você pode visualizar na tela de detalhes.",
    });
  } catch (error) {
    console.error(error);
  } finally {
    uploading.value = false;
  }
}

async function handleRemoveReceipt() {
  try {
    uploading.value = true;
    await updateReceipt({ id: props.item.id, remove_receipt: true });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Recibo removido",
      msg: "O recibo foi removido com sucesso.",
    });
  } catch (error) {
    console.error(error);
  } finally {
    uploading.value = false;
  }
}
</script>
